import { ECustomFieldType } from '../custom-field-types-enums';
import { EIntegrationStatus, TCustomField } from '../custom-fields.model';

export const isCustomFieldLockable = (field: TCustomField): boolean =>
  field.type !== ECustomFieldType.FORMULA && field.volyIntegrationActive !== EIntegrationStatus.ON;
